var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ls-nav-item"},[_c('span',[_vm._v(_vm._s(_vm.title))]),_c('LsIcon',{attrs:{"type":"chevron","color":"primary","size":"md"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }